import Vue from 'vue';
import App from './App.vue';
import router from './router';                      // 1.1.倒入router对象
import "babel-polyfill";
Vue.config.productionTip = false;

import 'element-ui/lib/theme-chalk/index.css';
import element from './util/elementui/index';
Vue.use(element)
router.beforeEach((to, from, next) => {        
  document.body.scrollTop = 0;          
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  next();
})
// import Video from 'node_modules/caniuse-lite/data/features/video.js';
// import "node_modules\video.js\dist\video-js.css";
import Video from "../node_modules/video.js/dist/video.js";
import "../node_modules/video.js/dist/video-js.css";
Vue.prototype.$video = Video;
new Vue({                                           // 6.使用倒入的router对象
  router,
  render: h => h(App),
}).$mount('#app')
